export default {
  title: 'Stories',
  name: 'flows',
  tableFields: [
    {
      name: 'label',
      title: 'Name',
      key: 'label'
    }
  ],
  tableLinks: [
    {
      name: 'id',
      path: 'Story'
    }
  ],
  urls: {
    getObjects: '/flows'
  }
}



// WEBPACK FOOTER //
// ./src/components/layout/automation-tab/list-definition.js